import {raf, caf, now} from '@essentials/raf'

/**  Copyright 2011, Joe Lambert.
 **  Free to use under the MIT license.
 **  http://www.opensource.org/licenses/mit-license.php
 **/
export const clearRequestTimeout = handle => {
  caf(handle.v || -1)
}
export const requestTimeout = (fn, delay) => {
  const start = now(),
    handle = {}

  const loop = () => {
    now() - start >= delay ? fn.call(null) : (handle.v = raf(loop))
  }

  handle.v = raf(loop)
  return handle
}
export default requestTimeout
